module.exports = __webpack_public_path__ + "static/media/avodocs.2bfe6561.png";